import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton';
import {
  ForumOutlined,
  WorkHistoryOutlined,
  RestoreOutlined,
} from "@mui/icons-material";
import { useMediaQuery, useTheme } from '@mui/material';

import CustomMenu from '../../../../../components/Menu';
import CustomMenuItem from '../../../../../components/Menu/CustomMenuItem';
import CustomModalDialog from '../../../../../components/Dialog/FormDialog';
import AddWorklog from '../../worklog/addWorklog/addWorklogDialog';
import MobileAssignParentCard from './mobile/MobileAssignParentCard';

import mobileDots from "../../../../../styles/svg/mobileDots.svg";
import ParentAssignIcon from "../../../../../styles/svg/parent-assign-edit.svg";


  function MobileCardMenu({ buttonStyles, cardId, card }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [openAssignParent, setOpenAssignParent] = useState(false);
    const [openAddWorklog, setOpenAddWorklog] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const cardData = card?.data?.data?.responseData;

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleAssignParent = () => {
      setOpenAssignParent(true);
      handleClose();
    };

    const handleAddWorklog = () => {
      setOpenAddWorklog(true);
      handleClose();
    };

    return (
      <>
        <IconButton
          aria-label="close"
          onClick={handleClick}
          sx={{
            ...buttonStyles,
            top: 10,
          }}
          className='mr-1'
        >
          <img src={mobileDots} alt="menu" />
        </IconButton>

        <CustomMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="mobile-card-details-menu"
        >
          <CustomMenuItem
            onClick={handleAddWorklog}
            className="mobile-card-details-menu-item"
          >
            <WorkHistoryOutlined className="icon" />
            Add Worklog
          </CustomMenuItem>
          <CustomMenuItem
            onClick={handleAssignParent}
            className="mobile-card-details-menu-item"
          >
            <img src={ParentAssignIcon} alt="parent-assign" className="icon" />
            {cardData?.parent_card_id ? "Change Parent" : "Assign Parent"}
          </CustomMenuItem>
        </CustomMenu>

        <CustomModalDialog
          open={openAssignParent}
          handleClose={() => setOpenAssignParent(false)}
          title={"Assign Parent"}
          fullScreen={fullScreen}
        >
          <MobileAssignParentCard
            onClose={() => setOpenAssignParent(false)}
            card={cardData}
            cardId={cardId}
          />
        </CustomModalDialog>

        {openAddWorklog && (
          <AddWorklog
            cardId={cardId}
            addWorklog={openAddWorklog}
            setAddWorklog={() => setOpenAddWorklog(false)}
            heading={"Add Work Log"}
            buttonName={"Save"}
          />
        )}
      </>
    );
  }
 

export default MobileCardMenu;